<template>
  <div class="wrapper-items wh100p">
    <section class="section-navs df">
      <div class="nav _themecolor active f-m">{{$t('item.itemManage')}}</div>
    </section>
    <section class="section-navs2 df-sb">
      <div class="navsbox scrollx" v-if="categorys.length">
        <div class="btn" @click="indexChange(-1)">
          <i class="el-icon-caret-left" style="font-size:32px;"></i>
        </div>
        <div class="navs df">
          <div
            v-for="(x,i) in categorys" :key="i" :ref="'item'+i"
            class="nav f-m" :class="{'_themecolor active':categoryIndex===i}"
            @click="changeCategory(x,i)">{{x.key?$t('item.'+x.key):x['name'+_lang]}}
          </div>
        </div>
        <div class="btn" @click="indexChange(1)">
          <i class="el-icon-caret-right" style="font-size:32px;"></i>
        </div>
      </div>
      <div class="btns df-c-fe">
        <div class="themebtn" @click="toggleAllStatus(false)" v-show="hasOnlinefalse">{{$t('item.sellOutCancel')}}</div>
        <div class="themebtn" @click="toggleAllStatus(true)" v-show="hasOnlineTrue" style="margin-left:20px;">{{$t('item.sellOut')}}</div>
      </div>
    </section>
    <section class="section-items df-w-fs">
      <div v-for="(x,i) in items" :key="i" class="item df-l-c-fs" :data-hide="$t('item.hide')" :class="{'item-noimg':!shopConfig_m.itemImgBEndEnable,'hide':x.saleOut}" @click="toggleStatus(i)">
        <div
          class="red-btn f-white df-c-ct" :class="x.leftCountShow===''?'_greenbackground':'_redbackground'"
          @click.prevent.stop="openDialogCount(x)">
          <!-- {{x.leftCountShow!==''?$t('item.yu')+x.leftCountShow:$t('common.setting')}} -->
          <span v-if="x.leftCountShow!==''">{{$t('item.yu')}}{{x.leftCountShow|tothousands}}</span>
          <span v-else>{{$t('common.setting')}}</span>
        </div>
        <div class="imgsquarebox" style="padding-top:80%" v-if="shopConfig_m.itemImgBEndEnable">
          <el-image :src="(x.imgId||x.itemImgId)|toimg" fit="cover" v-if="x.imgId||x.itemImgId"></el-image>
        </div>
        <div class="name w100p f-s df-c-ct">
          <span class="slm2">{{x['name'+_lang]||x['itemName'+_lang]}}</span>
        </div>
      </div>
    </section>

    <DialogStock ref="DialogStock" />

  </div>
</template>

<script>
import DialogStock from './components/DialogStock'
export default {
  name: 'items',
  components: { DialogStock },
  data() {
    return {
      categorys: [],
      categoryIndex: 0,
      categoryKey: '',
      catalogId: '',

      items: [],
      hasOnlineTrue: false,
      hasOnlinefalse: false,

      timer: null,
    }
  },
  watch: {
    sceneId_x(nval, oval) {
      if (nval && this.currentRoute === 'items') {
        this.init_afterSceneChange()
      }
    },
  },
  methods: {
    // 点击切换菜单
    indexChange(val) {
      const INDEX = this.categoryIndex + val
      if (0 <= INDEX && INDEX < this.categorys.length) {
        this.changeCategory(this.categorys[INDEX], INDEX)
      }
    },
    async changeCategory(item, index, autoOnlyBendRead =false) {
      if (!this.currentShopId) {
        return
      }
      this.categoryIndex = index
      this.categoryKey = item.key
      this.catalogId = item.id
      const REFS = this.$refs['item' + index]
      if (REFS && REFS.length) {
        // console.log(111, REFS[0])
        // https://www.jianshu.com/p/8b44deeee6eb
        // https://blog.csdn.net/weixin_45622540/article/details/105531888
        // REFS[0].scrollIntoView()
        // REFS[0].scrollIntoView(false)
        REFS[0].scrollIntoView({behavior: 'smooth', block: 'center', inline: 'center'})
      }
      this.items = await this.sendAjax_category(item.key, autoOnlyBendRead)
      this.handleAllStatus()
    },
    async sendAjax_category(key, autoOnlyBendRead = false) {
      let _R = []
      if (key) {
        switch (key) {
          case 'hot':
            _R = await this.getData('item', {
              shopId: this.currentShopId,
              // filterSceneId: this.sceneId_x,
              suggestion: true,
              suggestionOnline: true,
              online: true,
              pageSize: 999,
              // queryRealTimePrice: true,
              sortField: ['suggestShowOrder'],
              sortType: 'ASC',
              autoOnlyBendRead,
            })
            break
        }
      } else {
        _R = await this.getData('catalog2item', {
          shopId: this.currentShopId,
          // filterSceneId: this.sceneId_x,
          catalogId: this.catalogId,
          online: true,
          pageSize: 999,
          // sortField: ['showOrder'],
          // sortType: 'ASC',
          autoOnlyBendRead,
        })
      }
      console.log(`%c商品:`, 'color: #00f;', _R)
      // this.items = _R
      return _R
    },
    // 切換售罄
    async toggleStatus(index) {
      this.el_loading_x_save(true)
      // this.items[index].saleOut = !this.items[index].saleOut
      let id = this.items[index].itemId || this.items[index].id
      let saleOut = this.items[index].saleOut
      const _D = await this.setData('item', {
        id,
        saleOut: !saleOut
      })
      if (_D) {
        // this.items[index].saleOut = !this.items[index].saleOut
        this.items = await this.sendAjax_category(this.categoryKey)
        this.handleAllStatus()
      }
      this.el_loading_x_save(false)
    },
    // 一鍵售罄
    async toggleAllStatus(status) {
      this.el_loading_x_save(true)
      let rD = {
        shopId: this.currentShopId,
        saleOut: status,
      }
      switch (this.categoryKey) {
        case 'hot': rD.suggestion = true; break
        default: rD.catalogId = this.catalogId; break
      }
      await this.$api.online_status_tiggle(rD).then(res => {
        if (res.status == 0) {
          this.items.forEach(x => { x.saleOut = status })
          this.hasOnlinefalse = status
          this.hasOnlineTrue = !status
          // 控制菜單紅點顯隱
          this.$parent.$parent.$parent.itemsSellOutSearch()
        } else { this._status(res) }
      })
      this.el_loading_x_save(false)
    },
    // 處理全部統一状态
    handleAllStatus() {
      this.hasOnlinefalse = this.hasOnlineTrue = false
      for (let i = 0; i < this.items.length; i++) {
        const ITEM_ITEM = this.items[i]
        if (!ITEM_ITEM.saleOut) {
          this.hasOnlineTrue = true
          if (this.hasOnlinefalse) {break}
        }
        if (ITEM_ITEM.saleOut) {
          this.hasOnlinefalse = true
          if (this.hasOnlineTrue) {break}
        }
      }
      // 控制菜單紅點顯隱
      this.$parent.$parent.$parent.itemsSellOutSearch()
    },

    // 编辑库存
    openDialogCount(item) {
      console.log(`%c點擊的商品:`, 'color: #00f;', item)
      this.$refs.DialogStock.open(item)
    },

    // 获取数据
    async init_afterSceneChange() {
      // if (this.sceneId_x) {
        const _R_catalog = await this.getData('catalog', {
          shopId: this.currentShopId,
          // filterSceneId: this.sceneId_x,
          sortField: ['showOrder'],
          sortType: 'ASC',
          filterOnlineItem: true
        })
        console.log(`%c分類:`, 'color: #00f;', _R_catalog)
        let arr = []
        arr = await this.sendAjax_category('hot')
        arr.length && _R_catalog.unshift({key: 'hot', id: '0'})
        this.categorys = _R_catalog

        // 獲取 商品
        this.changeCategory(this.categorys[this.categoryIndex], this.categoryIndex, true)

        this.timer && clearInterval(this.timer)
        this.timer = setInterval(() => {
          this.changeCategory(_R_catalog[this.categoryIndex], this.categoryIndex, true)
        }, 30000)
      // }
    },
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init_afterSceneChange()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.timer && clearInterval(this.timer)
    next()
  },
}
</script>

<style lang='scss' scoped>
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;
  overflow: scroll hidden;z-index: 9;position: relative;
  .nav{padding: 0 10px;width: auto;white-space: nowrap;}
  .nav.active{font-weight: bold;}
  .draw-switch{position: absolute;top: 0;bottom: 0;right: 40px;margin: auto;width:40px;height:40px;}
}
.section-navs2{
  height: 80px;line-height: 80px;background: #fff;margin: 20px 0 20px 20px;
  .btns{min-width: 280px;margin: 0 20px;flex-shrink: 0;}

  .navsbox{
    position: relative;width: auto;display: flex;
    // &::before {
    //   content: '';display: inline-block;width: 0;height: 0;
    //   border: 10px solid transparent;border-right-color: #374978;
    //   position: absolute;left: 0;top: 0;bottom: 0;margin: auto;
    // }
    // &::after {
    //   content: '';display: inline-block;width: 0;height: 0;
    //   border: 10px solid transparent;border-left-color: #374978;
    //   position: absolute;right: 0;top: 0;bottom: 0;margin: auto;
    // }
    .btn{display: flex;justify-content: center;align-items: center;min-width: 40px;}
    .navs{overflow: scroll hidden;}
    .nav{padding: 0 10px;width: auto;white-space: nowrap;}
    .nav.active{font-weight: bold;}
  }
}
.section-items{
  height: calc(100% - 200px);overflow: hidden scroll;margin-top: 20px;padding-left: 20px;align-content:flex-start;
  .item{width: calc(16.66% - 10px);background: #fff;margin: 0 10px 20px 0;position: relative;}

  .name{height: 50px;color: #555;text-align: center;}
  .name span{line-height: 22px;padding: 0 4px;}
  .hide::after{
    content: attr(data-hide);display: inline-block;width: 100%;height: 100%;
    background: rgba($color: #000000, $alpha: 0.5);color: #fff;font-size: 20px;
    position: absolute;top: 0;left: 0;display: flex;justify-content: center;align-items: center;
  }
  .item.item-noimg{
    height: 80px;line-height: 80px;border: 1px solid #374978;border-radius: 4px;box-sizing: border-box;
    display: flex;justify-content: center;align-items: center;
    .name{color:#374978;}
  }

  .red-btn{
    position: absolute;top: 0;left: 0;min-width: 40px;height: 28px;padding: 0 8px;
    border-bottom-right-radius: 4px;z-index: 10;opacity: 0.8;
  }
}
</style>
